export const master = {
  levelsObject: [
    [
      {
        type: 'Listening',
        audio: '/static/audio/eigo-1.mp3',
        options: [
          { text: 'Wrong', bool: true },
          { text: 'Long', bool: false },
        ],
      },
      {
        type: 'Pronoucing',
        word: 'Rub',
      },
      {
        type: 'Listening',
        audio: '/static/audio/eigo-2.mp3',
        options: [
          { text: 'Song', bool: false },
          { text: 'Long', bool: true },
        ],
      },
      {
        type: 'Pronoucing',
        word: 'Year',
      },
    ],
    [
      {
        type: 'Pronoucing',
        word: 'Really',
      },
      {
        type: 'Listening',
        audio: '/static/audio/eigo-3.mp3',
        options: [
          { text: 'Wright', bool: false },
          { text: 'Right', bool: true },
        ],
      },
      {
        type: 'Spelling',
        audio: '/static/audio/eigo-2.mp3',
        word: 'long',
        description: 'Measuring a great distance from end to end.',
      },
      {
        type: 'Pronoucing',
        word: 'Cherry',
      },
      {
        type: 'Listening',
        audio: '/static/audio/eigo-4.mp3',
        options: [
          { text: 'Light', bool: true },
          { text: 'Right', bool: false },
        ],
      },
      {
        type: 'Spelling',
        audio: '/static/audio/eigo-1.mp3',
        word: 'wrong',
        description: 'Not correct or true; incorrect.',
      },
      {
        type: 'Pronoucing',
        word: 'Laugh',
      },
      {
        type: 'Pronoucing',
        word: 'Furnished',
      },
    ],
  ],
};
